export default "__VITE_ASSET__651213df__"